import {
	OriginConnectionPosition,
	OverlayConnectionPosition,
} from './connected-position';
import { ConnectedPositionStrategy } from './connected-position-strategy';
import { GlobalPositionStrategy } from './global-position-strategy';

export class OverlayPositionBuilder {
	/**
	 * Creates a global position strategy.
	 */
	global(): GlobalPositionStrategy {
		return new GlobalPositionStrategy(document);
	}

	/**
	 * Creates a relative position strategy.
	 * @param elementRef
	 * @param originPos
	 * @param overlayPos
	 */
	connectedTo(
		elementRef: HTMLElement,
		originPos: OriginConnectionPosition,
		overlayPos: OverlayConnectionPosition
	): ConnectedPositionStrategy {
		return new ConnectedPositionStrategy(
			originPos,
			overlayPos,
			elementRef,
			document
		);
	}
}
